import React from 'react';

const GridItem = ({ children, gridArea, ...props }) => {
  return (
    <div style={{ gridArea }} {...props}>
      {children}
    </div>
  );
};

export default GridItem;



// WEBPACK FOOTER //
// ./app/javascript/common/components/grid-item.jsx